import { Component, Input } from '@angular/core';
import { BaseMortgageApplicationComponent } from '../../../../../form-application/mortgage-application/pages/base-mortgage-application.component';
import { ReferenceDataConstants } from './../../../../../lib/constants/reference-data-constants';
import { DeclarationPageContentDto } from './../../../models/declaration-page-content-dto';
import { MortgageApplicationStore } from './../../../services/mortgage-application-store';

@Component({
  selector: 'boi-declaration-content',
  templateUrl: './declaration-content.component.html',
  styleUrls: ['./declaration-content.component.scss']
})
export class DeclarationContentComponent extends BaseMortgageApplicationComponent {
  @Input() public declarationDto: DeclarationPageContentDto;

  referenceDataConstants = ReferenceDataConstants;

  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }
}
